import {PayloadAction, createSlice} from '@reduxjs/toolkit'
import {AuthState, LoginResponse, MeResponse} from './types'
import {login, getMe, requestForgottenPassword, resetPassword} from './service'

const auth_token_key = process.env.REACT_APP_AUTH_TOKEN_KEY!

const initialState: AuthState = {
  me: null,
  actionLoading: false,
  error: null,
}
const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout: (state: AuthState) => {
      localStorage.removeItem(auth_token_key)
      state.me = null
    },
  },
  extraReducers: (builder) => {
    builder.addCase(login.pending, (state: AuthState) => {
      state.error = null
      state.actionLoading = true
    })
    builder.addCase(login.rejected, (state: AuthState) => {
      state.error = null
      state.actionLoading = false
    })
    builder.addCase(login.fulfilled, (state: AuthState, action: PayloadAction<LoginResponse>) => {
      const {user, token} = action.payload
      localStorage.setItem(auth_token_key, token)
      state.me = user
      state.error = null
      state.actionLoading = false
    })

    builder.addCase(getMe.pending, (state: AuthState) => {
      state.error = null
      state.actionLoading = true
    })
    builder.addCase(getMe.rejected, (state: AuthState) => {
      state.error = null
      state.actionLoading = false
    })
    builder.addCase(getMe.fulfilled, (state: AuthState, action: PayloadAction<MeResponse>) => {
      const {user} = action.payload
      state.me = user
      state.error = null
      state.actionLoading = false
    })
    builder.addCase(requestForgottenPassword.pending, (state: AuthState) => {
      state.error = null
      state.actionLoading = true
    })
    builder.addCase(requestForgottenPassword.rejected, (state: AuthState) => {
      state.error = null
      state.actionLoading = false
    })
    builder.addCase(requestForgottenPassword.fulfilled, (state: AuthState) => {
      state.error = null
      state.actionLoading = false
    })
    builder.addCase(resetPassword.pending, (state: AuthState) => {
      state.error = null
      state.actionLoading = true
    })
    builder.addCase(resetPassword.rejected, (state: AuthState) => {
      state.error = null
      state.actionLoading = false
    })
    builder.addCase(resetPassword.fulfilled, (state: AuthState) => {
      state.error = null
      state.actionLoading = false
    })
  },
})

export default authSlice.reducer
export const actions = authSlice.actions
